import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import type { State } from 'types/redux'
import { updatePlaylistReportParams } from '@disco/state-management/actions/ReportActions'
import { loadTags } from '@disco/state-management/actions/TagActions'
import TagSelector from 'components/common/tag-selector'
type OwnProps = {
  formKey: string
}

function mapStateToProps(state: State, ownProps: OwnProps): any {
  return {
    value: state.reports.playlistReport.form[ownProps.formKey].map(
      tag => tag.label,
    ),
  }
}

function mapDispatchToProps(
  dispatch: ReturnType<typeof import('hooks/use-redux')['useDispatch']>,
  ownProps: OwnProps,
): {
  onChange: (value: string) => unknown
  loadTags: typeof loadTags
} {
  return {
    onChange(value) {
      dispatch(
        updatePlaylistReportParams({
          [ownProps.formKey]: value,
        }),
      )
    },

    ...bindActionCreators(
      {
        loadTags,
      },
      dispatch,
    ),
  }
}

class ReportTags extends React.Component<{
  value: string[]
  onChange: (value: string) => unknown
  loadTags: typeof loadTags
  disabled?: boolean
}> {
  componentDidMount() {
    this.props.loadTags()
  }

  render() {
    const { value, onChange, loadTags, disabled } = this.props
    return (
      <TagSelector
        placeholder="Select tags"
        selectedTags={value}
        onFocus={loadTags}
        onChange={onChange}
        clearable
        disabled={disabled}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportTags) as any
